import { render, staticRenderFns } from "./ToolheadMoves.vue?vue&type=template&id=40588cf4&scoped=true&"
import script from "./ToolheadMoves.vue?vue&type=script&lang=ts&"
export * from "./ToolheadMoves.vue?vue&type=script&lang=ts&"
import style0 from "./ToolheadMoves.vue?vue&type=style&index=0&id=40588cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40588cf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtnToggle,VCol,VRow})
